import React from 'react';
import complementosList from './ComplementosList';

const Complementos = (props) => {
  const { input, data, complemento, complementos = {}, onChange } = props;

  let Component = null;

  if (complemento) {
    Component = complementosList[complemento];
  }

  const handleOnChange = (data) => {
    onChange({
      ...complementos,
      ...data
    });
  }

  const handleOnCancel = (complemento) => {
    onChange({
      ...complementos,
      [complemento]: undefined,
    });
  }

  return (
    <div>
      { !!Component && (
        <Component
          data={ data }
          input={ input }
          onChange={ handleOnChange }
          onCancel={ handleOnCancel }
        />
      )}
    </div>
  )
}

export default Complementos;
